module.exports = __webpack_public_path__ + "static/horizon_screen2-ba76f6b47c4fdf07433b9d0b28f8f379.png";